// src/pages/PageMenu/CompanyDefinitions.jsx
// تعريفات الشركة — بالتصميم الموحّد (MenuKit) مع دعم الترجمة

import React from "react";
import { useAuth } from "../../context/AuthContext";
import { MenuPage } from "../../components/Menu/MenuKit";

import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PeopleIcon from "@mui/icons-material/People";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import TuneIcon from "@mui/icons-material/Tune";

export default function CompanyDefinitions() {
  const { hasAnyPermission } = useAuth();
  // نفس مفاتيح السيرفر ([RequirePermission]) — يكفي أي واحد منها
  const canAny = (...keys) => hasAnyPermission(keys);

  const sections = [
    {
      key: "definitions",
      titleKey: "companyDefinitions.sectionTitle", titleFallback: "التعريفات الأساسية",
      subtitleKey: "companyDefinitions.sectionDesc", subtitleFallback: "بيانات المنشأة والفروع والمستخدمين",
      icon: <TuneIcon />, color: "#4F46E5",
      items: [
        canAny("Company.Edit", "Settings.View", "Settings.Edit") && { key: "profile", nameKey: "companyDefinitions.companyProfile", nameFallback: "بيانات المنشأة", icon: <BusinessIcon />, color: "#4F46E5", link: "/company/profile" },
        canAny("Branch.Manage", "Settings.Edit") && { key: "branches", nameKey: "companyDefinitions.branchDefinition", nameFallback: "الفروع", icon: <ApartmentIcon />, color: "#0891B2", link: "/branches" },
        canAny("User.Manage") && { key: "users", nameKey: "companyDefinitions.users", nameFallback: "المستخدمين", icon: <PeopleIcon />, color: "#2563EB", link: "/UserForm" },
        canAny("Role.Manage", "Security.Manage") && { key: "roles", nameKey: "companyDefinitions.roles", nameFallback: "الأدوار والصلاحيات", icon: <AdminPanelSettingsOutlinedIcon />, color: "#7C3AED", link: "/roles" },
      ],
    },
  ];

  return (
    <MenuPage
      titleKey="companyDefinitions.title" titleFallback="تعريفات الشركة"
      subtitleKey="companyDefinitions.subtitle" subtitleFallback="بيانات المنشأة والفروع والمستخدمين"
      icon={<SettingsSuggestOutlinedIcon />}
      sections={sections}
    />
  );
}
